import angular = require("angular");
import TPL = require("templates");
import {LoginController} from "../../modals/login";

export class HireDirective {

  template = TPL.navigationDirectives.hire;
  scope = {
    params: "=params"
  };
  modal;
  link;

  constructor($modal, $rootScope) {
    this.link = (scope, el, attrs)=> {
        scope.vm = {
          openLoginModal: (which) => {

            if (which == "login") {
              scope.vm.currentModal = LoginController.openLoginModal($modal, scope.vm, $rootScope);
            } else {
              scope.vm.currentModal = LoginController.openSignupModal($modal, scope.vm, $rootScope);
            }
          }
        };
    }
  }


  static factory() {
    var tmp = (a, b) => new HireDirective(a, b);
    tmp.$inject = ["$uibModal", "$rootScope"];
    return tmp;
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/hire.ts
 **/